module.exports = __webpack_public_path__ + "img/app-pc-down-btn.f14ecfa2.jpg";